export default __webpack_public_path__ + "static/media/Rangers.0a871d1c.png";